(function () {
    const banner = document.getElementById("banner")
    const bannerVideo = document.getElementById("banner-video");
    const playPauseBtn = document.getElementById("bv-pause");

    let pauseRequested = false;

    if (banner && bannerVideo && playPauseBtn) {
        //console.log("found a video")
        banner.addEventListener("mouseenter", () => {
            //console.log("mouseenter");
            bannerVideo.pause()
        })
        banner.addEventListener("mouseleave", () => {
            //console.log("mouseleave");
            if (!pauseRequested) {
                bannerVideo.play()
            }
        })
        playPauseBtn.addEventListener("click", () => {
            pauseRequested = !pauseRequested;
            handlePlayPause()
        })

    }

    function handlePlayPause() {
        const pauseEl = playPauseBtn.getElementsByClassName("pause")[0];
        const playEl = playPauseBtn.getElementsByClassName("play")[0];

        if (pauseRequested) {
            hideElement(pauseEl)
            showElement(playEl)
            bannerVideo.pause()
        } else {
            hideElement(playEl)
            showElement(pauseEl)
            bannerVideo.play()
        }
    }

    function hideElement(el) {
        el.classList.remove("show")
        el.classList.add("hide")
    }

    function showElement(el) {
        el.classList.remove("hide")
        el.classList.add("show")
    }

})();